// extracted by mini-css-extract-plugin
export var button = "_14-0";
export var buttonContent = "_14-e";
export var buttonGroup = "_14-c";
export var dontRestrainIconWidth = "_14-a";
export var dropdownButton = "_14-b";
export var iconContainer = "_14-9";
export var lg = "_14-4";
export var md = "_14-3";
export var pending = "_14-f";
export var sm = "_14-2";
export var spinner = "_14-d";
export var squared = "_14-8";
export var wrapText = "_14-g";
export var xl = "_14-5";
export var xs = "_14-1";
export var xxl = "_14-6";
export var xxxl = "_14-7";